<svelte:options customElement="clw-icon-stop" />

<script lang="ts">
    let className = '';
    export let fillColor = 'white';
    export { className as class };
</script>

<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class={className}>
    <g clip-path="url(#clip0_2092_120400)">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.84375 3.75C6.02324 3.75 5.23633 4.07595 4.65614 4.65614C4.07595 5.23633 3.75 6.02324 3.75 6.84375V17.1562C3.75 17.9768 4.07595 18.7637 4.65614 19.3439C5.23633 19.9241 6.02324 20.25 6.84375 20.25H17.1562C17.9768 20.25 18.7637 19.9241 19.3439 19.3439C19.9241 18.7637 20.25 17.9768 20.25 17.1562V6.84375C20.25 6.02324 19.9241 5.23633 19.3439 4.65614C18.7637 4.07595 17.9768 3.75 17.1562 3.75H6.84375Z"
            fill={fillColor}
        />
    </g>
    <defs>
        <clipPath id="clip0_2092_120400">
            <rect width="16.5" height="16.5" fill={fillColor} transform="translate(3.75 3.75)" />
        </clipPath>
    </defs>
</svg>
